var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Twitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 480",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface25502529"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 480,
    height: 480,
    style: {
      fill: "rgb(7.058824%,7.058824%,7.058824%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 448 110.992188 C 432.6875 117.792969 416.238281 122.367188 398.976562 124.433594 C 416.609375 113.871094 430.128906 97.152344 436.496094 77.214844 C 420.015625 86.992188 401.742188 94.097656 382.289062 97.9375 C 366.71875 81.34375 344.542969 70.976562 320 70.976562 C 272.863281 70.976562 234.65625 109.199219 234.65625 156.320312 C 234.65625 163.007812 235.425781 169.535156 236.863281 175.761719 C 165.9375 172.207031 103.054688 138.222656 60.945312 86.574219 C 53.617188 99.183594 49.40625 113.839844 49.40625 129.503906 C 49.40625 159.105469 64.464844 185.230469 87.359375 200.527344 C 73.375 200.078125 60.207031 196.238281 48.703125 189.855469 C 48.703125 190.222656 48.703125 190.558594 48.703125 190.929688 C 48.703125 232.289062 78.113281 266.785156 117.167969 274.609375 C 110.015625 276.558594 102.464844 277.601562 94.671875 277.601562 C 89.183594 277.601562 83.824219 277.054688 78.625 276.078125 C 89.488281 309.984375 121.007812 334.671875 158.351562 335.359375 C 129.152344 358.257812 92.351562 371.902344 52.351562 371.902344 C 45.472656 371.902344 38.671875 371.503906 31.984375 370.703125 C 69.761719 394.910156 114.609375 409.039062 162.816406 409.039062 C 319.808594 409.039062 405.632812 278.992188 405.632812 166.207031 C 405.632812 162.511719 405.550781 158.832031 405.390625 155.167969 C 422.078125 143.121094 436.558594 128.097656 448 110.992188 Z M 448 110.992188 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Twitter);
export default __webpack_public_path__ + "static/media/icons8-twitter.421641476930073a135404c1646ac7b3.svg";
export { ForwardRef as ReactComponent };